import React from 'react';
import { useAuth } from '../store/AuthContext';
import { LoadingSpinner } from './LoadingSpinner';

export const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div className="flex h-screen items-center justify-center">
                <LoadingSpinner size="lg" />
            </div>
        );
    }

    if (!user) {
        return (
            <div className="flex h-full flex-col items-center justify-center p-6 text-center">
                <h2 className="text-xl font-bold text-text-heading">Login Required</h2>
                <p className="mt-2 text-text-muted">You need to be logged in to access this feature.</p>
                <a
                    href="/settings?action=login"
                    className="mt-4 rounded-lg bg-primary-600 px-4 py-2 text-white hover:bg-primary-700 text-sm font-medium"
                >
                    Go to Login Page
                </a>
            </div>
        );
    }

    return <>{children}</>;
};
